import { useQuery } from '@tanstack/react-query';
import { listProducts } from '../services/products.api';
import type { ProductListQuery } from '../types';

export function useProducts(query?: ProductListQuery) {
  return useQuery({
    queryKey: ['products', 'list', query],
    queryFn: () => listProducts(query),
  });
}
